import { sendFeedback as sentrySendFeedback } from "@sentry/react";

type Input = Parameters<typeof sentrySendFeedback>;

export function sendFeedback(feedback: Input["0"], options: Input["1"]) {
  if (import.meta.env.DEV) return Promise.resolve();

  return sentrySendFeedback(feedback, options);
}
